<script>
    import {toggleDarkMode} from "../../config/app-state-config";
    import Switch from "../../components/ui/Switch.svelte";

    const social = [
        {url: 'https://www.linkedin.com/in/matej-kormanik', icon: 'linkedin'},
        {url: 'https://github.com/Matej-Kormanik', icon: 'github'},
        {url: 'mailto:matej@kormanik.me', icon: 'envelope'},
        {url: 'https://www.instagram.com/matkormi/', icon: 'instagram'}
    ]
    const header = 'Matej Kormaník';
    // const old = `Software developer focused on full-stack web app development using Java, and JavaScript technologies. I share here some stories & pictures from my travels, free time, and hobbies. Welcome.`;
    const about = `
    Hi there! I'm a freelance software developer with a passion for exploring the world through travel, snowboarding, and sports.
    When I'm not coding, you can find me hitting the slopes or trying out new outdoor activities.
    On this page, I share my personal blog and photos from my adventures, along with updates on my latest software projects.
    Join me on my journey as I balance work and play.`;
</script>
<!--------------------------------------------------------------------------------------------------------------------->

<svelte:head>
    <meta name="description" content="Personal website of Matej Kormanik" />
</svelte:head>

<div class="home">
    <img src="resources/images/ja.jpeg" alt={header} />
    <h1>{header}</h1>
    <p>{about}</p>

    <div class="social">
        <nav>
            {#each social as soc}
                <a href={soc.url} target='_blank' class='fa fa-{soc.icon}'><span></span></a>
            {/each}
        </nav>
        <div class="switch">
            <Switch on:switch={(event) => {toggleDarkMode(event.detail)}} />
        </div>
    </div>

</div>

<!--------------------------------------------------------------------------------------------------------------------->
<style>
    .home {
        width: 66%;
        margin: 1.5rem auto 0;
    }

    img {
        width: 160px;
        height: 160px;
        border-radius: 50%;
        display: block;
        margin: 0 auto;
        filter: grayscale(20%);
    }

    h1 {
        font-size: 2rem;
        text-align: center;
        padding: 1rem 0 2rem;
    }
    p {
        padding-top: 2.5rem;
        font-size: 1.5rem;
        font-family: 'Source Sans Pro',serif;
    }

    /* ============   FOOTER    ===============*/
    .social {
        width: 44%;
        margin: 2rem auto .5rem;
    }

    nav {
        display: flex;
        justify-content: space-around;
    }

    .switch {
        display: none;
        position: absolute;
        bottom: 20%;
        left: 50%;
        -ms-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
    }

    .fa {
        color: var(--black-color);
        padding: 4px;
        border: 1px solid var(--black-color);
        border-radius: 35%;
        margin-right: 5px;
        filter: opacity(0.6);
    }
    /*==================================     MEDIA     ======================================*/
    @media screen and (max-width: 500px) {
        .home {
            width: 100%;
            height: inherit;
            margin-top: .5rem;
        }
        img {
            width: 150px;
            height: 150px;
        }
        p {
            font-size: 1.1rem;
            padding: 0 1.3rem;
        }
    }
    @media screen and (min-width: 501px) {
        .social {
            display: none;
        }
    }
</style>
